<script>
  import Modal from "./../../../shared/Modal.svelte";
  import { Circle } from "svelte-loading-spinners";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import * as ls from "local-storage";
  import config from "../../../stores/config";

  const dispatch = createEventDispatcher();
  const authData = { headers: { authorization: ls.get("jwt") } };

  export let orderID;
  export let styleID;
  export let itemID;

  export let _id;
  export let qtyReq;
  export let qtyUsed;
  export let qtyWasted;
  export let uPrice;
  export let inventoryLevel;

  let derivedName = $config?.items?.find(({ value }) => value == itemID)?.label;

  let editedMat = {
    itemID,
    qtyReq,
    qtyUsed,
    qtyWasted,
    uPrice,
  };

  let showEditMatForm = false;
  let editMatLoading = false;

  const handleEditStyle = async (e) => {
    if (editedMat.qtyReq == undefined) alert("⚠ Quantity Required missing!");
    else if (editedMat.qtyUsed == undefined) alert("⚠ Qty Used missing!");
    else if (editedMat.qtyWasted == undefined) alert("⚠ Qty Wasted missing!");
    else {
      editMatLoading = true;

      let data = { ...editedMat };

      axios
        .put(
          `${$config.backendURL}/orders/${orderID}/edit-material/${styleID}/${_id}`,
          data,
          authData
        )
        .then((res) => {
          showEditMatForm = false;
          editMatLoading = false;
          dispatch("update");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleDelete = () => {
    let confirmDelete = confirm(`Do you wish to delete ${derivedName}?`);

    if (confirmDelete) {
      axios
        .delete(
          `${$config.backendURL}/orders/${orderID}/delete-material/${styleID}/${_id}`,
          authData
        )
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  const handleDecrement = () => {
    let qty = prompt(`Enter the quantity to take from stock. Example. 20`);
    qty = qty.replaceAll(/[^\d.-]/g, "");

    if (inventoryLevel < qty) {
      alert(
        `\n⚠ There's not enough of ${derivedName} in Stock to assign the requested quantity.`
      );
      return;
    }

    if (qty > qtyReq - qtyUsed) {
      alert(
        `\n⚠ You cannot take from stock a quantity beyond what is requested for this material.`
      );
      return;
    }

    axios
      .put(
        `${$config.backendURL}/items/decrement/${itemID}/${orderID}/${styleID}/${_id}`,
        { qty },
        authData
      )
      .then((res) => {
        dispatch("update");
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };

  const handleAdd = () => {
    let qty = prompt(`Enter the quantity to add to stock. Example. 40`);
    qty = qty.replaceAll(/[^\d.-]/g, "");

    axios
      .put(`${$config.backendURL}/items/increment/${itemID}`, { qty }, authData)
      .then((res) => {
        dispatch("update");
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };
</script>

<div class="tr tracking-wider border-b border-gray-100">
  <div
    style="min-width: 12.5rem; max-width: 12.5rem;"
    class="flex items-center"
  >
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    <button
      class="text-base btn btn-blue-outline mr-2"
      on:click={handleDecrement}
    >
      <i class="fas fa-plus-circle" />
    </button>
    <button
      class="text-base btn btn-green-outline mr-2"
      on:click={(e) => (showEditMatForm = true)}
    >
      <i class="fas fa-edit" />
    </button>
  </div>
  <div style="min-width: 15rem; max-width: 15rem;">{derivedName}</div>
  <div
    style="min-width: 8rem; max-width: 8rem;"
    class="text-red-400 font-semibold flex items-center"
  >
    {inventoryLevel}
    <!-- REMOVED HERE HERE HERE -->
    <!-- <button class="text-base btn btn-red-outline ml-2" on:click={handleAdd}>
      <i class="fas fa-plus" />
    </button> -->
  </div>
  <div style="min-width: 7rem; max-width: 7rem;">
    {Number.parseFloat(Number.parseFloat(qtyReq).toFixed(2))}
  </div>
  <div style="min-width: 7rem; max-width: 7rem;">{qtyUsed}</div>
  {#if qtyReq - qtyUsed >= 0}
    <div style="min-width: 7rem; max-width: 7rem;">
      {Number.parseFloat(Number.parseFloat(qtyReq - qtyUsed).toFixed(2))}
    </div>
  {:else}
    <div
      style="min-width: 7rem; max-width: 7rem;"
      class="text-green-400 font-semibold"
    >
      {Number.parseFloat(Number.parseFloat((qtyReq - qtyUsed) * -1).toFixed(2))}
      unused
    </div>
  {/if}
  <div style="min-width: 7rem; max-width: 7rem;">{qtyWasted}</div>
</div>

<!-- EDIT MODAL -->
<Modal
  show={showEditMatForm}
  on:modalClose={() => {
    showEditMatForm = false;
  }}
>
  <div class="grid gap-y-2">
    <div class="flex items-center uppercase">
      <i class="text-green-400 fas fa-exclamation-circle text-xl mr-2" />
      <div class="col-span-2 text-base">
        {derivedName}
      </div>
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity Required :</div>
      <input
        class="col-span-2"
        bind:value={editedMat.qtyReq}
        type="number"
        step="any"
        placeholder="Quantity or meters required"
      />
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity Wasted :</div>
      <input
        class="col-span-2"
        bind:value={editedMat.qtyWasted}
        type="number"
        step="any"
        placeholder="Quantity Wasted"
      />
    </div>

    {#if editMatLoading}
      <div class="flex items-center justify-center btn btn-green-outline">
        <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
        <span class="ml-4">Please wait...</span>
      </div>
    {:else}
      <!-- else content here -->
      <div class="flex">
        <button
          style="width: 100%;"
          class="btn btn-green"
          on:click={handleEditStyle}
        >
          <i class="fas fa-check-circle mr-3" />
          Save
        </button>
        <button
          style="width: 100%;"
          class="ml-4 btn btn-gray"
          on:click={(e) => (showEditMatForm = false)}
        >
          <i class="fas fa-times-circle mr-3" />
          Close
        </button>
      </div>
    {/if}
  </div>
</Modal>

<!-- EDIT MODAL -->
<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
